import isEqual from 'lodash/isEqual';
import { flattenDesignTokens } from './index';
import { getDesignPresetDependencies } from './presets';
import type { DesignDefinition, DesignTokenSet } from './types';

/** Library choices exclude identical Story snapshots; existing IDs still belong to Story. */
export function getLibraryTokenOptions(story?: DesignTokenSet, library?: DesignTokenSet) {
	const localTokens = new Map(flattenDesignTokens(story).map(token => [token.id, token]));
	return flattenDesignTokens(library).filter(token => !isEqual(localTokens.get(token.id), token));
}

export function getLibraryPresetOptions(story?: DesignDefinition, library?: DesignDefinition) {
	const localPresets = new Map(story?.presets?.map(preset => [preset.id, preset]));
	const localTokens = new Map(flattenDesignTokens(story?.tokens).map(token => [token.id, token]));
	const libraryTokens = new Map(flattenDesignTokens(library?.tokens).map(token => [token.id, token]));
	return (library?.presets ?? []).filter(preset => {
		if (!isEqual(localPresets.get(preset.id), preset)) return true;
		return getDesignPresetDependencies(preset).some(id => !isEqual(localTokens.get(id), libraryTokens.get(id)));
	});
}
